import { Button } from '@velocity/ui';
import React from 'react';
import { useSelector } from 'react-redux';
import Layout from '../../../layout';
import { EDevice } from '../../../redux/sequence/enums';
import { RootState } from '../../../redux/store';
import { formatUTCDateToGerman } from '../../../utils/sanitize-data';
import ArrowList from '../../b2b/components/arrow-list/arrow-list';
import Contact from '../contact/contact';
import { ReactComponent as CancelledSvg } from '../images/lease-application-cancel.svg';
import { ReactComponent as CancelledSmallSvg } from '/src/assets/svg/small_error.svg';

const StatusCancelled: React.FC = () => {
  // Store
  const { activeApplication } = useSelector(
    (state: RootState) => state.leaseApp,
  );

  const { device } = useSelector((state: RootState) => state.sequence);

  const headline = (
    <>
      {device === EDevice.MOBILE && (
        <CancelledSmallSvg className='status-svg' />
      )}
      <div>Dein Leasingantrag wurde erfolgreich storniert</div>
    </>
  );

  const getSubHeading = () => {
    return `Du hast die Stornierung deines Leasingantrags am ${formatUTCDateToGerman(
      activeApplication?.cancel_details?.cancelled_time,
    )} erfolgreich durchgeführt.`;
  };

  return (
    <Layout
      heading={headline}
      subHeading={getSubHeading()}
      hasFullSize={true}
      className='status-overview top-96 grid'
      style={{ gridTemplateRows: '15% 60%' }}
    >
      <div
        className='half-half-columns cancelled top-36'
        style={{ alignItems: 'start' }}
      >
        {(device === EDevice.DESKTOP || device === EDevice.TABLET) && (
          <CancelledSvg className='status-svg' />
        )}
        <div className='flex flex-col gap-4'>
          <div className='content-bold'>Dein Antrag wurde beendet</div>

          <ArrowList
            className='dark-grey content-normal'
            list={[
              'Der Leasingantrag wurde wie gewünscht storniert und wird nicht weiter bearbeitet.',
            ]}
          />

          <div className='content-bold'>
            Du möchtest ein anderes Fahrzeug leasen?
          </div>

          <ArrowList
            className='dark-grey content-normal'
            list={[
              'Über den Button gelangst du zurück zur Fahrzeugsuche und kannst jederzeit ein neues Angebot auswählen.',
            ]}
          />

          <Button
            variant='secondary-filled'
            size='m'
            fullWidth
            margin={{ y: '06' }}
            onClick={() => window.open(import.meta.env.VITE_MOPO_URL, '_self')}
          >
            Zur Fahrzeugsuche
          </Button>

          <Contact />
        </div>
      </div>
    </Layout>
  );
};

export default StatusCancelled;
